const get = require('lodash/get')

module.exports = (location) => {
  const classification = get(location, 'additionalData.classification')
  return (classification === 'PPMV' || classification === 'General Retailer')
}
